import { Container } from '$app/shared/components/Container';
import styled from 'styled-components';

export const ContainerStyled = styled(Container)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`

export const DivStyled = styled.div`
height: 100%;
margin: 0;
background: #fbfbfb;

.ant-btn-primary {
  margin-bottom: 8px;
}`;

export const ContainFormRight = styled.div`
  position: fixed;
  background: #fff;
  padding: 18px;
  top: 50px;
  z-index: 999;
  right: 15px;
  bottom: 50px;
  width: 270px;
  box-shadow: -2px 0px 5px 0px hsla(0,0%,81%,.77);
`;
